import moment from "moment";

import { getTimezoneOffset } from "date-fns-tz";

export const getUTCFormatedDate = (date) => {
  const parsedDate = new Date(date);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneOffset = getTimezoneOffset(timeZone, parsedDate);
  const correctedDate = moment(parsedDate).add(
    Math.abs(timezoneOffset / 1000),
    "seconds"
  );
  return correctedDate;
};
